module.exports = __webpack_public_path__ + "static/media/PAE_AVAX.e914457b.svg";